import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-footer',
	templateUrl:'./WaFooterPluginCompPage.html',
	styles: [],
	styleUrls:['./WaFooterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaFooterPluginCompPage
{
	mdContent_1132 = `\`\`\`java
import com.jwebmp.webawesomepro.WaFooter;
\`\`\``;
	mdContent_1133 = `\`\`\`java
new WaFooter&lt;&gt;()
\`\`\``;
}
